module.exports = __webpack_public_path__ + "static/garantie-5-02f7a52d4e9556fc300a260344d51f29.svg";